import React, { useContext, useState, useEffect } from "react";
import { AuthContext } from "../contexts/auth";
import { useParams, Link } from "wouter";
import { fetchEmployee } from "../services/api";
import { updateAnagraficaEmployee } from "../services/api_anagrafica_employee";
import Swal from "sweetalert2";
import ComboboxAutocompleteAPI from "./combobox_autocomplete_api";
import { getCitizenshipsList, getCitiesList, getEducationLevelsList, getPoliceHeadQuartersList, getResidencePermitReasonsList, getResidencePermitTypesList  } from "../services/api_resources";
import { getLocationsCompany } from '../services/api_anagrafica_employee';
import Fetching from "./fetching";

export default function AnagraficaTabEmployee({ setUnsavedChanges }) {
    const { profile, token } = useContext(AuthContext);
    const { codiceFiscale } = useParams();
    const [employee, setEmployee] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [isError, setIsError] = useState(false);
    const [isEditWorker, setIsEditWorker] = useState(false);
    const [editedEmployee, setEditedEmployee] = useState({
        sex: employee && employee.employee.sex ? employee.employee.sex : "",
        birth_date: employee && employee.employee.birth_date ? employee.employee.birth_date : "",
        birth_place: employee && employee.employee.birth_place ? employee.employee.birth_place : "",
        domicilio_comune: employee && employee.domicilio_comune ? employee.employee.domicilio_comune : "",
        domicilio_cap: employee && employee.domicilio_cap ? employee.employee.domicilio_cap : "",
        domicilio_indirizzo: employee && employee.domicilio_indirizzo ? employee.employee.domicilio_indirizzo : "",
        citizenship: employee && employee.citizenship ? employee.employee.citizenship : "",
        education_level: employee && employee.education_level ? employee.employee.education_level : "",
        location: employee && employee.location ? employee.employee.location : "",
        residence_permit_type: employee && employee.employee.residence_permit_type ? employee.employee.residence_permit_type : "",
        residence_permit_number: employee && employee.employee.residence_permit_number ? employee.employee.residence_permit_number : "",
        residence_permit_reason: employee && employee.employee.residence_permit_reason ? employee.employee.residence_permit_reason : "",
        residence_permit_end: employee && employee.employee.residence_permit_end ? employee.employee.residence_permit_end : "",
        residence_permit_police_hq: employee && employee.employee.residence_permit_police_hq ? employee.employee.residence_permit_police_hq : "",
        mansione: employee && employee.employee.mansione ? employee.employee.mansione : "",
        livello: employee && employee.employee.livello ? employee.employee.livello : "",
    });
    const [errors, setErrors] = useState({
        domicilio_indirizzo: '',
        domicilio_cap: '',
      });
    const [initialValues, setInitialValues] = useState({});
    const [isSaving, setIsSaving] = useState(false);


    useEffect(() => {
      if (token) {
        setIsLoading(true);
        fetchEmployee(token, codiceFiscale)
          .then((res) => {
            setEmployee(res);
            setEditedEmployee(res.employee);
            setIsLoading(false);
            setIsError(false);
          })
          .catch((err) => {
            console.error(err);
            setIsLoading(false);
            setIsError(true);
          });
      }
    }, [token, codiceFiscale]);

    const handleComboBoxChange = (field, res) => {
        const value = res ? res : null;
        
        setEditedEmployee(prevState => ({
            ...prevState,
            [field]: value,
        }));
        setUnsavedChanges(true);
    };

    const handleCapChange = (e) => {
        const { name, value } = e.target;
        const numericValue = value.replace(/\D/g, '');
    
        setEditedEmployee(prevState => ({
            ...prevState,
            [name]: numericValue
        }));
        setUnsavedChanges(true);
    };

    const handleCitizenshipChange = (selectedCitizenship) => {
        setEditedEmployee(prevState => {
            const isUE = selectedCitizenship ? selectedCitizenship.is_ue : null;
    
            const updatedState = {
                ...prevState,
                citizenship: selectedCitizenship,
                is_ue: isUE,
            };

            if (isUE) {
                updatedState.residence_permit_type = null;
                updatedState.residence_permit_end = null;
                updatedState.residence_permit_reason = null;
                updatedState.residence_permit_number = null;
                updatedState.residence_permit_police_hq = null;
                updatedState.residence_permit_type = null;
            }
    
            return updatedState;
        });
        setUnsavedChanges(true);
    };
    

    const handleChange = (e) => {
        const { name, value } = e.target;
    
        if (name === 'residence_permit_end' || name === 'birth_date') {
            if (value === '') {
                setEditedEmployee(prevState => ({
                    ...prevState,
                    [name]: null
                }));
            } else {
                const formattedDate = new Date(value).toISOString().split('T')[0];
                setEditedEmployee(prevState => ({
                    ...prevState,
                    [name]: formattedDate
                }));
            }
        } else {
            const newValue = name === 'residence_permit_type' ? parseInt(value) : value;
            setEditedEmployee(prevState => ({
                ...prevState,
                [name]: newValue
            }));
            setUnsavedChanges(true);
        }
    };   

    const validateForm = () => {
        let formIsValid = true;
        const newErrors = {};
    
        if (!editedEmployee.domicilio_indirizzo?.trim()) {
            newErrors.domicilio_indirizzo = 'Questo campo è obbligatorio';
            formIsValid = false;
        } else {
            newErrors.domicilio_indirizzo = '';
        }
    
        if (!editedEmployee.domicilio_cap?.trim()) {
            newErrors.domicilio_cap = 'Questo campo è obbligatorio';
            formIsValid = false;
        } else {
            newErrors.domicilio_cap = '';
        }
        
        setErrors(newErrors);
        return formIsValid;
    };

    const handleSave = async (e) => {
        e.preventDefault();
        setIsSaving(true);
    
        if (!validateForm()) {
            setIsSaving(false);
            return;
        }
        
        try {    
            const dataToSend = { ...editedEmployee, sex: editedEmployee?.sex?.toLowerCase() };

            for(const propName in dataToSend) {
                const props = dataToSend[propName];
    
                if(props && props.hasOwnProperty('id')) {
                    dataToSend[propName] = props.id;
                }
            }

            if (dataToSend.is_ue) {
                dataToSend.residence_permit_type = null;
                dataToSend.residence_permit_end = null;
                dataToSend.residence_permit_reason = null;
                dataToSend.residence_permit_police_hq = null;
                dataToSend.residence_permit_number = null;
            }

            if (!dataToSend.location) {
                dataToSend.location = null;
            }

            delete dataToSend.active_contract;
            delete dataToSend.last_contract;
    
            await updateAnagraficaEmployee(token, employee.employee.id, dataToSend);
            setIsSaving(false);
            setUnsavedChanges(false); 
            Swal.fire({
                title: 'Dipendente Modificato!',
                text: 'Modifica del dipendente andata a buon fine.',
                icon: 'success',
                confirmButtonText: 'OK',
            });
            setInitialValues({});
            // window.history.back(); 
        } catch (error) {
            setIsSaving(false);
            console.error('Errore durante la modifica:', error);
        
            let errorMessage = 'Errore durante la modifica. Per favore riprova.';
        
            if (!error.response) {
                errorMessage = 'Errore, riprova più tardi.';
            } else if (error.response && error.response.data) {
                const errorData = error.response.data;
                const errorMessages = [];
        
                Object.keys(errorData).forEach((key) => {
                const messageArray = errorData[key];
                if (Array.isArray(messageArray)) {
                    errorMessages.push(...messageArray);
                } else if (typeof messageArray === 'string') {
                    errorMessages.push(messageArray);
                }
                });
        
                if (errorMessages.length > 0) {
                    errorMessage = errorMessages.join(' ');
                }
            }
        
            Swal.fire({
                icon: 'error',
                title: 'Errore',
                text: errorMessage,
                confirmButtonText: 'OK',
            });
        } finally {
            setIsSaving(false);
        }
    };


    if(isLoading) return <Fetching /> 
    if (isError) return <div>Error loading data</div>;


    return (
       <div className="min-h-full">

            <main className="mt-10 pb-8">
                <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:max-w-7xl lg:px-8">
                    {isLoading ? (
                        <p>Caricamento in corso...</p>
                    ) : isError ? (
                        <p>Errore nel caricamento dei dati.</p>
                    ) : (
                        employee && (
                            <>    
                                <form>
                                    <div className="grid grid-cols-1 md:grid-cols-3 gap-4 pb-6">
                                        <div className="flex flex-col justify-between h-full">
                                            <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="sex">
                                                Sesso
                                            </label>
                                
                                            <select
                                                className="border-none shadow-md rounded w-full py-2 px-3 text-gray-700 focus:outline-none focus:ring-offset-none"
                                                id="sex"
                                                name="sex"
                                                value={editedEmployee?.sex?.toLowerCase() || ""}
                                                onChange={handleChange}
                                            >
                                                <option value="">Seleziona</option>
                                                <option value="m">M</option>
                                                <option value="f">F</option>
                                            </select>
                                            {errors.sex && (
                                                <p className="text-red-500 text-sm mt-1">{errors.sex}</p>
                                            )}
                                        </div>
                                        <div className="flex flex-col justify-between h-full">
                                            <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="birthDate">
                                                Data di Nascita
                                            </label>
                                            <input
                                                className="border-none shadow-md rounded w-full py-2 px-3 text-gray-700 focus:outline-none focus:ring-offset-none"
                                                id="birthDate"
                                                name="birth_date"
                                                type="date"
                                                value={editedEmployee.birth_date || ""}
                                                onChange={handleChange}
                                            />
                                        </div>
                                        <div className="flex flex-col justify-between h-full">
                                            <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="birthPlace">
                                                Luogo di Nascita
                                            </label>
                                            <input
                                                className="border-none shadow-md rounded w-full py-2 px-3 text-gray-700 focus:outline-none focus:ring-offset-none"
                                                id="birthPlace"
                                                name="birth_place"
                                                type="text"
                                                value={editedEmployee.birth_place || ""}
                                                onChange={handleChange}
                                            />
                                        </div>
                                        <div className="flex flex-col justify-between h-full">
                                            <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="domicilioComune">
                                                Comune Domicilio
                                            </label>
                                            <ComboboxAutocompleteAPI
                                                getData={(query) => getCitiesList(token, query)}
                                                getDisplay={(res) => `${res?.codice_catastale} - ${res?.name}`}
                                                getId={(res) => res?.id}
                                                onChange={(id) => handleComboBoxChange('domicilio_comune', id)}
                                                currentValue={editedEmployee?.domicilio_comune}
                                            />
                                        </div>
                                        <div className="flex flex-col justify-between h-full">
                                            <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="domicilioCap">
                                                CAP Domicilio
                                            </label>
                                            <input
                                                className="border-none shadow-md rounded w-full py-2 px-3 text-gray-700 focus:outline-none focus:ring-offset-none"
                                                id="domicilioCap"
                                                name="domicilio_cap"
                                                type="text"
                                                value={editedEmployee.domicilio_cap || ""}
                                                onChange={handleCapChange}
                                                required
                                            />
                                            {errors.domicilio_cap && (
                                                <p className="text-red-500 text-sm mt-1">{errors.domicilio_cap}</p>
                                            )}
                                        </div>
                                        <div className="flex flex-col justify-between h-full">
                                            <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="domicilioIndirizzo">
                                                Indirizzo Domicilio
                                            </label>
                                            <input
                                                className="border-none shadow-md rounded w-full py-2 px-3 text-gray-700 focus:outline-none focus:ring-offset-none"
                                                id="domicilioIndirizzo"
                                                name="domicilio_indirizzo"
                                                type="text"
                                                value={editedEmployee.domicilio_indirizzo || ""}
                                                onChange={handleChange}
                                                required
                                            />
                                            {errors.domicilio_indirizzo && (
                                                <p className="text-red-500 text-sm mt-1">{errors.domicilio_indirizzo}</p>
                                            )}
                                        </div>
                                        <div className="flex flex-col justify-between h-full">
                                            <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="cittadinanza">
                                                Cittadinanza
                                            </label>
                                            <ComboboxAutocompleteAPI
                                                getData={(query) => getCitizenshipsList(token, query)}
                                                getDisplay={(res) => res ? `${res?.code_mf} - ${res?.des_citizenship}` : ''}
                                                getId={(res) => res?.id}
                                                onChange={handleCitizenshipChange}
                                                currentValue={editedEmployee?.citizenship}
                                            />
                                        </div>
                                        <div className="flex flex-col justify-between h-full">
                                            <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="educationLevel">
                                                Livello Istruzione
                                            </label>
                                            <ComboboxAutocompleteAPI
                                                getData={(query) => getEducationLevelsList(token, query)}
                                                getDisplay={(res) => res?.description}
                                                getId={(res) => res?.id}
                                                onChange={(id) => handleComboBoxChange('education_level', id)}
                                                currentValue={editedEmployee?.education_level ? (editedEmployee.education_level) : null}
                                            />
                                        </div>
                                        <div className="flex flex-col justify-between h-full">
                                            <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="location">
                                                Sede di Lavoro
                                            </label>
                                            <ComboboxAutocompleteAPI
                                                getData={(query) => getLocationsCompany(token, query)}
                                                getDisplay={(res) => res ? `${res?.name || ''} - ${res?.address || ''}` : ''}
                                                getId={(res) => res?.id}
                                                onChange={(id) => handleComboBoxChange('location', id)}
                                                currentValue={editedEmployee?.location ? (editedEmployee.location) : null}
                                            />
                                        </div>
                                        <div className="flex flex-col justify-between h-full">
                                            <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="iban">
                                                Iban
                                            </label>
                                            <input
                                                className="border-none shadow-md rounded w-full py-2 px-3 text-gray-700 focus:outline-none focus:ring-offset-none"
                                                id="iban"
                                                name="iban"
                                                type="text"
                                                value={editedEmployee.iban || ""}
                                                onChange={handleChange}
                                            />
                                        </div>
                                        <div className="flex flex-col justify-between h-full">
                                            <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="external_reference">
                                                ID Gestionale Esterno
                                            </label>
                                            <input
                                                className="border-none shadow-md rounded w-full py-2 px-3 text-gray-700 focus:outline-none focus:ring-offset-none"
                                                id="external_reference"
                                                name="external_reference"
                                                type="text"
                                                value={editedEmployee.external_reference || ""}
                                                onChange={handleChange}
                                            />
                                        </div>
                                        <div className="flex flex-col justify-between h-full">
                                            <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="external_location_reference">
                                                ID Sede Lavoro Gestionale Esterno
                                            </label>
                                            <input
                                                className="border-none shadow-md rounded w-full py-2 px-3 text-gray-700 focus:outline-none focus:ring-offset-none"
                                                id="external_location_reference"
                                                name="external_location_reference"
                                                type="text"
                                                value={editedEmployee.external_location_reference || ""}
                                                onChange={handleChange}
                                            />
                                        </div>
                                    </div> 
                                    {editedEmployee.is_ue === false && (
                                        <>
                                            <hr />
                                            <div className="flex items-center py-4">
                                                <div className="uppercase block text-indigo-700 text-md font-bold mr-4">Lavoratore Extra UE</div>
                                            </div>
            
                                            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 pb-6">
                                                <div className="flex flex-col justify-between h-full">
                                                    <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="titoloSoggiorno">
                                                        Titolo di Soggiorno
                                                    </label>
                                                    <ComboboxAutocompleteAPI
                                                        getData={(query) => getResidencePermitTypesList(token, query)}
                                                        getDisplay={(res) => `${res?.code} - ${res?.description}`}
                                                        getId={(res) => res?.id}
                                                        onChange={(id) => handleComboBoxChange('residence_permit_type', id)}
                                                        currentValue={editedEmployee?.residence_permit_type}
                                                    />
                                                </div>
                                                <div className="flex flex-col justify-between h-full">
                                                    <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="numeroPermessoSoggiorno">
                                                        Numero Permesso di Soggiorno
                                                    </label>
                                                    <input
                                                        className="border-none shadow-md rounded w-full py-2 px-3 text-gray-700 focus:outline-none focus:ring-offset-none"
                                                        id="numeroPermessoSoggiorno"
                                                        name="residence_permit_number"
                                                        type="text"
                                                        value={editedEmployee.residence_permit_number || ""}
                                                        onChange={handleChange}
                                                    />
                                                </div>
                                                <div className="flex flex-col justify-between h-full">
                                                    <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="motivoTitoloSoggiorno">
                                                        Motivo Titolo di Soggiorno
                                                    </label>
                                                    <ComboboxAutocompleteAPI
                                                        getData={(query) => getResidencePermitReasonsList(token, query)}
                                                        getDisplay={(res) => `${res?.code} - ${res?.description}`}
                                                        getId={(res) => res?.id}
                                                        onChange={(res) => handleComboBoxChange('residence_permit_reason', res)}
                                                        currentValue={editedEmployee?.residence_permit_reason}
                                                    />
                                                </div>
                                                <div className="flex flex-col justify-between h-full">
                                                    <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="scadenzaTitoloSoggiorno">
                                                        Scadenza Titolo di Soggiorno
                                                    </label>
                                                    <input
                                                        className="border-none shadow-md rounded w-full py-2 px-3 text-gray-700 focus:outline-none focus:ring-offset-none"
                                                        id="scadenzaTitoloSoggiorno"
                                                        name="residence_permit_end"
                                                        type="date"
                                                        value={editedEmployee.residence_permit_end || ''}
                                                        onChange={handleChange}
                                                    />
                                                </div>
                                                <div className="flex flex-col justify-between h-full">
                                                    <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="questura">
                                                        Questura Rilascio Titolo di Soggiorno
                                                    </label>
                                                    <ComboboxAutocompleteAPI
                                                        getData={(query) => getPoliceHeadQuartersList(token, query)}
                                                        getDisplay={(res) => `${res?.code} - ${res?.description}`}
                                                        getId={(res) => res?.id}
                                                        onChange={(id) => handleComboBoxChange('residence_permit_police_hq', id)}
                                                        currentValue={editedEmployee?.residence_permit_police_hq}
                                                    />
                                                </div>
                                            </div>
                                        </>
                                    )}

                                    <div>
                                        <button 
                                            className="bg-indigo-700 hover:bg-indigo-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline w-full mt-6"
                                            onClick={handleSave}
                                            disabled={isSaving}
                                        >
                                            {isSaving ? 'Salvataggio...' : 'Salva'}
                                        </button>
                                    </div>
                                </form>

                            </>
                        )
                    )}
                </div>
            </main>
        </div>
    );
}
